import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Football = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M19.071 4.929a9.936 9.936 0 00-7.07-2.938 9.943 9.943 0 00-7.072 2.938c-3.899 3.898-3.899 10.243 0 14.142a9.94 9.94 0 007.073 2.938 9.936 9.936 0 007.07-2.937c3.899-3.898 3.899-10.243-.001-14.143zM12.181 4h-.359c.061-.001.119-.009.18-.009s.118.008.179.009zm6.062 13H16l-1.258 2.516a7.956 7.956 0 01-2.741.493 7.96 7.96 0 01-2.746-.494L8 17.01H5.765a7.96 7.96 0 01-1.623-3.532L6 11 4.784 8.567a7.936 7.936 0 011.559-2.224 7.994 7.994 0 013.22-1.969L12 6l2.438-1.625a8.01 8.01 0 013.22 1.968 7.94 7.94 0 011.558 2.221L18 11l1.858 2.478A7.952 7.952 0 0118.243 17z",
    key: "k0"
  }), React.createElement("path", {
    d: "M8.5 11l1.5 4h4l1.5-4L12 8.5z",
    key: "k1"
  }));
});
Football.displayName = 'Football';
export var FootballDimensions = {
  height: 24,
  width: 24
};